@switch (type) {
  @case ('RATIO') {
    <ng-container *ngTemplateOutlet="ratioInput"></ng-container>
  }
  @default {
    <awc-form-input
      #formInputRef
      [ngClass]="{ 'readonly': readOnly, green: highlight === 'green', red: highlight === 'red' }"
      [label]="label"
      [placeholder]="placeholder"
      [value]="displayValue"
      [suffixText]="suffixText"
      [id]="id"
      [readOnly]="readOnly"
      [disabled]="disabled"
      [loading]="loading"
      [size]="AWCFormElementSize.SMALL"
      (valueChange)="handleValueChange($event)"
      [showConfirmationButton]="true"
      (keydown.enter)="onKeydownEnter(formInputRef)"
      (formFieldFocused)="formFieldFocused()"
      (formFieldBlurred)="formFieldBlurred()"
      awcTooltip [awcTooltipText]="tooltip ?? (isValueTruncated ? value : '')"
    ></awc-form-input>
  }
}

<ng-template #ratioInput>
  <div class="input-cont" [style.cursor]="'default'">
    <div>
      <span *ngIf="label" class="label">{{label}}</span>
      <ng-container>
        <span class="label ratio-label"> : {{altLabel}}</span>
<!--        <span class="label"> Ratio</span>-->
      </ng-container>
    </div>
    <div class="form-element" [ngClass]="{ 'readonly': readOnly, 'disabled' : disabled, 'red': highlight === 'red' }">
      <input tabindex="0" min="0" max="100" class="inputField" type="number" [placeholder]="placeholder" step="1" [value]="value" (input)="checkInput($event)" (focus)="setInitial($event)" (keydown)="stopProp($event)" (keyup.enter)="updateValue($event)" (blur)="updateValue($event)" [readOnly]="loading || readOnly" >

      <span *ngIf="!loading" class="label ratio-label"> : {{ratioValue}}</span>
      <awc-icon *ngIf="loading; else unitEl" class="input-loading" [icon]="spinner"></awc-icon>
      <ng-template #unitEl>
        <span *ngIf="unit" class="unit">{{ unitStr }}</span>
      </ng-template>
    </div>
  </div>
</ng-template>
